import { render, staticRenderFns } from "./CreateCostDialog.vue?vue&type=template&id=10204a80&scoped=true"
import script from "./CreateCostDialog.vue?vue&type=script&lang=js"
export * from "./CreateCostDialog.vue?vue&type=script&lang=js"
import style0 from "./CreateCostDialog.vue?vue&type=style&index=0&id=10204a80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10204a80",
  null
  
)

export default component.exports